import Vue from 'vue'
import VueRouter from 'vue-router'

import {Parameter} from '@/router/Parameter/Parameter';

import HomePage from "@/views/HomePage.vue";

import {Physician} from "@/router/Physician.js";
import {Pharmacy} from "@/router/Pharmacy.js";
import {Wholesaler} from "@/router/Wholesaler.js";

import {VisitPhysician} from "@/router/VisitPhysician.js";
import {VisitPharmacy} from "@/router/VisitPharmacy.js";
import {VisitWholesaler} from "@/router/VisitWholesaler.js";
import {ActivityReport} from "@/router/ActivityReport";

import {Expense} from "@/router/Expense.js";

import {TourPlan, TourPlanCalendar} from "@/router/TourPlan.js";

import {DeduplicationPhysician} from "@/router/DeduplicationPhysician.js";
import {DeduplicationPharmacy} from "@/router/DeduplicationPharmacy.js";
import {DeduplicationWholesaler} from "@/router/DeduplicationWholesaler.js";

import {AnalysisPhysician} from "@/router/Analysis/AnalysisPhysician.js";
import {AnalysisPharmacy} from "@/router/Analysis/AnalysisPharmacy.js";
import {AnalysisWholesaler} from "@/router/Analysis/AnalysisWholesaler.js";

import {PromotionCampaign} from "@/router/PromotionCampaign.js";
import {ProductRange} from "@/router/ProductRange.js";
import {Product} from "@/router/Product.js";
import {Delegate} from "@/router/Delegate.js";
import {Role} from "@/router/Role.js";
import {DataSelect} from "@/router/DataSelect.js";

import {AnalysisCustomerDetail} from "@/router/Analysis/AnalysisCustomerDetail.js";
import {AnalysisVisitDetail} from "@/router/Analysis/AnalysisVisitDetail.js";

Vue.use(VueRouter);


const routes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
        children: [
            Parameter,

            Physician,
            Pharmacy,
            Wholesaler,

            VisitPhysician,
            VisitPharmacy,
            VisitWholesaler,

            ActivityReport,

            Expense,

            TourPlan,
            TourPlanCalendar,

            DeduplicationPhysician,
            DeduplicationPharmacy,
            DeduplicationWholesaler,

            AnalysisPhysician,
            AnalysisPharmacy,
            AnalysisWholesaler,

            PromotionCampaign,
            ProductRange,
            Product,
            Delegate,
            Role,
            DataSelect,
        ],
    },
    AnalysisCustomerDetail,
    AnalysisVisitDetail,
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Setting/Login/LoginView.vue'),
    },
    {
        path: '/reset_password',
        name: 'reset_password',
        component: () => import('@/views/Setting/ResetPassword/ResetPassword.vue'),
    },
    {
        path: '*',
        name: 'not_found',
        component: () => import('@/views/PageNotFound.vue')
    },
]

const router = new VueRouter({
    routes
})

export default router
